export const resolveIdDescriptor = (descriptors, id) => {
  const descriptor = descriptors.find(r => r.get('id') === id);
  if (descriptor) {
    return `${id} - ${descriptor.get('description')}`;
  }
  return null;
};

export const resolveDescriptor = (descriptors, id) => {
  const descriptor = descriptors.find(r => r.get('id') === id);
  if (descriptor) {
    return descriptor.get('description');
  }
  return null;
};

export const resolveMinMax = (name, min, max, messages) => {
  if (min != null || max != null) {
    if (min != null && max != null) {
      if (min === max) {
        messages.push(`${name} = ${max}`);
      } else {
        messages.push(`${min} <= ${name} >= ${max}`);
      }
    } else if (min != null) {
      messages.push(`${name} >= ${min}`);
    } else {
      messages.push(`${name} <= ${max}`);
    }
  }
};

export const resolveMinMaxDescription = (name, min, max, descriptors, messages) => {
  if (min != null || max != null) {
    const minDesc = resolveDescriptor(descriptors, min);
    const maxDesc = resolveDescriptor(descriptors, max);
    if (min != null && max != null) {
      if (min === max) {
        messages.push(`${name} = ${maxDesc}`);
      } else {
        messages.push(`${minDesc} <= ${name} >= ${maxDesc}`);
      }
    } else if (min != null) {
      messages.push(`${name} >= ${minDesc}`);
    } else {
      messages.push(`${name} <= ${maxDesc}`);
    }
  }
};

export const resolveDoubtfulDescription = (descriptors, id) => {
  const d = id.toLocaleLowerCase();
  let doubtful;
  if (d === 'n') {
    doubtful = 'ok';
  } else if (d === 'y') {
    doubtful = 'Doubtful';
  } else if (d === 'm') {
    doubtful = 'Meteorological';
  } else if (d === 'a') {
    doubtful = 'Atmospheric';
  }
  return doubtful;
};
